import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "../../styles/Testimonial.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const Testimonials = () => {
  const swiperRef = useRef(null);

  const testimonials = [
    {
      quote:
        "Memuaskan, Hasil pengerjaan rapi,mulai dr jahit, printing, dan cara kerja desain bagus. Pelayanan juga baik, intinya langganan teruss … mantap 👍🏻 . Sukses selalu originality ❤️❤️ ️👍🏻",
      name: "Binjas Monster Joyo",
      title: "Komunitas",
      image: "assets/img/testimonials/MONSTER.jpg",
    },
    {
      quote: "kita kerja sama sudah hampir masuk 4 tahun😀😀",
      name: "Selera Pedas Merchendise (SPM)",
      title: "Clothing Brand",
      image: "assets/img/testimonials/SPM.jpg",
    },
    {
      quote:
        "sejauh ini baik dan memuaskan untuk pelayanannya. Selalu bisa menerima komplain dengan baik dan memperbaiki. Sebelum cetak sablon kaos selalu proofing utk konfirmasi warna sablon kaos sudah sesuai permintaan atau belum. Selalu tanggap dan fast respon kalau mau order.",
      name: "Role PSHT",
      title: "Komunitas",
      image: "assets/img/testimonials/PSHT.jpg",
    },
    {
      quote: "bagus kakk,proses cepat dan sangat memuaskan",
      name: "Cellino",
      title: "Clothing Brand",
      image: "assets/img/testimonials/CELLINO.jpg",
    },
  ];

  return (
    <section
      id="testimonials"
      className="testimonials section light-background"
    >
      <div className="container section-title" data-aos="fade-up">
        <h2>TESTIMONIALS</h2>
        <p>
          What Are They{" "}
          <span className="description-title">Saying About Us</span>
        </p>
      </div>
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          modules={[Autoplay, Pagination]}
          loop={true}
          speed={600}
          autoplay={{ delay: 5000 }}
          slidesPerView="auto"
          pagination={{ el: ".swiper-pagination", clickable: true }}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-item">
                <div className="row gy-4 justify-content-center">
                  <div className="col-lg-6">
                    <div className="testimonial-content">
                      <p>
                        <i className="bi bi-quote quote-icon-left"></i>
                        <span>{testimonial.quote}</span>
                        <i className="bi bi-quote quote-icon-right"></i>
                      </p>
                      <h3>{testimonial.name}</h3>
                      <h4>{testimonial.title}</h4>
                      <div className="stars">
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 text-center">
                    <img
                      src={testimonial.image}
                      className="img-fluid testimonial-img"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div className="swiper-pagination"></div>
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
